angular.module('invoice')
    .factory('InvoiceManagerialCategory', function ($resource) {
        return $resource('/crm/api/invoice-managerial-category/:id', {}, {
            list: {method: 'GET', isArray: false},
            get: {method: 'GET'},
            update: {method: 'PUT', params: {id: "@id"}},
            remove: {method: 'DELETE'},
            autocomplete: {method: 'GET', isArray: true, url: '/crm/api/invoice-managerial-category/autocomplete'}
        });
    })
    .service('InvoiceManagerialCategoryService', function ($rootScope, toastr, modals, InvoiceManagerialCategory) {
        this.edit = id => {
            return InvoiceManagerialCategory.get({id: id}, entity => editModal(entity))
        }
        this.addModal = () => {
            let entity = {
                id: null
            }
            return editModal(entity)
        };
        this.remove = item => {
            return modals.confirmDelete(item.name, () => InvoiceManagerialCategory.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast('invoice-managerial-category.updated')));
        }

        function editModal(entity) {
            return modals.open('app/invoice/managerial-category/edit-modal.html', 'InvoiceManagerialCategoryDialogController', entity, {size: "sm"}, "$ctrl");
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('invoiceManagerialCategoryList', {
            parent: 'app',
            url: '/settings/invoice-managerial-category?{page:int}&{size:int}&sort&search&pack',
            data: {
                authorities: ['ROLE_INVOICE_SETTINGS_READ']
            },
            views: {
                'content@': 'invoiceManagerialCategoryList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (InvoiceManagerialCategory, $stateParams) => InvoiceManagerialCategory.list(angular.copy($stateParams)).$promise
            }
        })
    })
